import Play from './play';
import Songs from './songs';
import Teacher from './teacher';
import Guitars from './guitars';
import Gift from './gift';
import Download from './download';
import Login from './login';
import App from './app';
import Coupons from './coupons';
import Congrats from './congrats';
import Error from './error';
import ChromaticTuner from './chromatic-tuner';
import Metronome from './metronome';
import Rockin from './rockin';
import SadGuitar from './sad-guitar';
import NoCable from './no-cable';
import Quote from './quote';
import BrokenHeart from './broken-heart';
import DeleteAccount from './delete-account';
import Instruments from './instruments';
import Guitar from './guitar';
import Follow from './follow';
import ThumbUp from './thumb-up';
import Clock from './clock';
import Money from './money';
import Spotlight from './spotlight';
import AllInstruments from './all_instruments';

export default {
    AllInstruments,
    Play,
    Teacher,
    Songs,
    Guitars,
    Gift,
    Download,
    Login,
    App,
    Coupons,
    Congrats,
    Error,
    ChromaticTuner,
    Metronome,
    Rockin,
    SadGuitar,
    NoCable,
    Quote,
    BrokenHeart,
    DeleteAccount,
    Instruments,
    Guitar,
    Follow,
    ThumbUp,
    Clock,
    Money,
    Spotlight,
};
